'use client';
import { useEffect, useState } from 'react';
import { useCart } from '@/contexts/CartContext';

export default function HeroSection() {
  const [isHydrated, setIsHydrated] = useState(false);
  const { addToCart, inventory } = useCart();

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  const handleAddToCart = () => {
    if (inventory > 0) {
      addToCart({
        id: 'igniss-001',
        name: 'IGNISS // 001',
        price: 49,
        quantity: 1,
        image: 'https://images.unsplash.com/photo-1602874801006-e0c4c93c7c3c?w=400',
      });
    }
  };

  const isSoldOut = inventory === 0;

  return (
    <section className="relative min-h-screen flex flex-col items-center justify-center pt-32 pb-20 overflow-hidden bg-background">
      {/* Background Video */}
      <div className="absolute inset-0 w-full h-full overflow-hidden">
        {isHydrated && (
          <video
            autoPlay
            loop
            muted
            playsInline
            className="w-full h-full object-cover opacity-30"
          >
            <source
              src="https://cdn.coverr.co/videos/coverr-candles-burning-in-the-dark-5301/1080p.mp4"
              type="video/mp4"
            />
          </video>
        )}
        <div className="absolute inset-0 bg-gradient-to-b from-background/80 via-background/60 to-background"></div>
      </div>

      {/* Hero Content */}
      <div className="max-w-6xl mx-auto px-6 relative z-10 text-center">
        <h1 className="hero-title font-serif font-bold tracking-tight leading-none mb-8 text-foreground">
          IGNISS // 001 <br className="hidden md:block" />
          <span className="italic font-normal">{isSoldOut ? 'This release has concluded.' : 'Atmosphere, controlled.'}</span>
        </h1>

        {!isSoldOut && (
          <p className="text-xl md:text-2xl text-muted-foreground max-w-2xl mx-auto leading-relaxed mb-12">
            Limited release. 1,000 units only. Never restocked.
          </p>
        )}

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          {isSoldOut ? (
            <div className="bg-muted text-muted-foreground px-10 py-5 rounded-full text-lg font-bold">
              Sold Out — Never Restocked
            </div>
          ) : (
            <button 
              onClick={handleAddToCart}
              className="group flex items-center justify-center gap-3 bg-primary text-primary-foreground px-10 py-5 rounded-full text-lg font-bold hover:bg-foreground hover:text-background smooth-hover shadow-xl"
            >
              Add to Cart
              <svg
                className="w-5 h-5 group-hover:translate-x-1 transition-transform"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M13 7l5 5m0 0l-5 5m5-5H6" />
              </svg>
            </button>
          )}
        </div>
      </div>
    </section>
  );
}